import { useState } from "react";
import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function FAQ({ lang }: Props) {
  const tr = t[lang].faq;
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="section faq">
      <h2 className="section-title">{tr.title}</h2>
      <div className="faq-list">
        {tr.items.map((item, i) => (
          <div className={`faq-item ${open === i ? "open" : ""}`} key={i} onClick={() => setOpen(open === i ? null : i)}>
            <div className="faq-question">
              <span>{item.q}</span>
              <span className="faq-arrow">{open === i ? "▲" : "▼"}</span>
            </div>
            {open === i && <div className="faq-answer">{item.a}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
